import React from 'react';
import { queryHelpers, useMediaQuery } from '@leagueplatform/genesis-core';
import { ResponsiveHeaderNavProps } from './nav-types.types';
import { DesktopNav } from './desktop-nav/desktop-nav-bar.component';
import { HeaderNavBar } from './header-nav-bar.component';
import { MobileNavBar } from './mobile-nav/mobile-nav-bar.component';

/**
 * An out of the box responsive app navigation header that stays at the top of the screen.
 * @param {object} props
 * @prop {string} props.navLinks - an array of navigation links to be displayed in the app bar.
 * @prop {string} props.userSettingsLinks - an array of user settings links to be displayed inside the user dropdown menu.
 * @prop {string} props.logo - a logo to be displayed on the right of the nav bar
 * @prop {number} [props.navHeight] - the height of the nav bar.
 * @prop {boolean} [props.enableSkipToContent] - adds the skip to main content link item to the nav bar.
 * @prop {GDSStyleObject} [props.headerStyling] - Genesis css styling overrides for the wrapping <header> element.
 * @prop {GDSStyleObject} [props.navListStyling] - Genesis css styling overrides for the inner navigation <ul> element
 */
export const ResponsiveHeaderNav = ({
  navLinks,
  userSettingsLinks,
  logo,
  enableSkipToContent,
  headerStyling,
  navHeight,
  navListStyling,
}: ResponsiveHeaderNavProps) => {
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));
  return (
    <HeaderNavBar
      enableSkipToContent={enableSkipToContent}
      headerStyling={headerStyling}
      navHeight={navHeight}
      navListStyling={navListStyling}
    >
      {!isMobile && (
        <DesktopNav
          navLinks={navLinks}
          userSettingsLinks={userSettingsLinks}
          logo={logo}
        />
      )}
      {isMobile && (
        <MobileNavBar
          navLinks={navLinks}
          userSettingsLinks={userSettingsLinks}
          logo={logo}
        />
      )}
    </HeaderNavBar>
  );
};
